import MyActivityOpenHouses from "./components/MyActivityOpenHouses";
import myActivityStore from "./redux/myActivityStore";
import withInitializationMyActivity from "./redux/utilities/withInitializationMyActivity";

const enhanceMyActivity = withInitializationMyActivity(myActivityStore);

const MyActivityOpenHousesApp = enhanceMyActivity(MyActivityOpenHouses);

export default MyActivityOpenHousesApp;
